import React, { useCallback, useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Box,
  Tooltip,
  Image,
} from "@chakra-ui/react";
import useScraper from "./useScraper";
import { translate as trans } from "../Trans/Trans";
import Preloader from "../Preloader/Preloader";

const itemWrapperStyles = {
  position: "relative",
  width: "128px",
  height: "128px",
  borderRadius: "base",
  backgroundColor: "whiteAlpha.200",
};

const itemInnerStyles = {
  width: "100%",
  height: "100%",
  overflow: "hidden",
  borderRadius: "base",
};

const PostLinkImageSelectorModal = ({ link, onSelect, onClose }) => {
  const { fetchScraperData } = useScraper();
  const [images, setImages] = useState([]);
  const [inProgress, setInProgress] = useState(false);

  const fetchLinkImages = useCallback(
    async (fetchLink) => {
      setInProgress(true);

      const fetchedData = await fetchScraperData(fetchLink);

      setImages(fetchedData?.images || []);

      setInProgress(false);
    },
    [setImages, setInProgress, fetchScraperData]
  );

  const handleSelect = useCallback(
    (url) => {
      onSelect?.(url);
      onClose?.();
    },
    [onSelect, onClose]
  );

  useEffect(() => {
    fetchLinkImages(link);
  }, []);

  return (
    <Modal
      autoFocus={false}
      returnFocusOnClose={false}
      isOpen
      onClose={onClose}
      size="xl"
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          {trans("post_link_preview.image_selector.modal_title")}
        </ModalHeader>
        <ModalBody>
          <Box paddingBottom="2">
            {inProgress ? (
              <Preloader />
            ) : (
              <Box display="flex" flexWrap="wrap" margin="-0.5">
                {images.map((item) => (
                  <Box key={item} margin="0.5" sx={itemWrapperStyles}>
                    <Box sx={itemInnerStyles}>
                      <Tooltip
                        label={trans("post_link_preview.image_selector.select")}
                        hasArrow
                        placement="bottom"
                      >
                        <Box
                          width="100%"
                          height="100%"
                          cursor="pointer"
                          onClick={() => handleSelect(item)}
                        >
                          <Image
                            src={item}
                            fallback={<></>}
                            width="100%"
                            height="100%"
                            objectFit="contain"
                          />
                        </Box>
                      </Tooltip>
                    </Box>
                  </Box>
                ))}
              </Box>
            )}
          </Box>
        </ModalBody>
        <ModalCloseButton />
      </ModalContent>
    </Modal>
  );
};

PostLinkImageSelectorModal.propTypes = {
  link: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

PostLinkImageSelectorModal.defaultProps = {};

export default PostLinkImageSelectorModal;
